import ConfirmationModal from './components/ConfirmationModal.vue';
export { ConfirmationModal };
